module.exports = __webpack_public_path__ + "img/prop-praline-3.24220de1.webp";